import { render, staticRenderFns } from "./BottomInformation.vue?vue&type=template&id=53f4f9b2"
import script from "./BottomInformation.vue?vue&type=script&lang=js"
export * from "./BottomInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports